<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import type { EcommerceItem } from '@/types/shared/player-config'
import { T } from '@tolgee/vue'
import ShopCard from '@/components/ShopCard.vue'
import type { EcommercePrizeCardItem } from '@/types/shop'
import BoostCard from '@/components/BoostCard.vue'
import { useShop } from '@/composables/game/shop'

const props = defineProps<{
	show: boolean
	item: EcommerceItem | EcommercePrizeCardItem
	bgFadeClass?: string
	wrapperClass?: string
}>()
defineEmits(['hide'])
const { isBOGO } = useShop()

</script>

<template>
  <TheBottomSheet
    :show="show"
    :bg-fade-class="props.bgFadeClass"
    :wrapper-class="props.wrapperClass"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center gap-y-12">
      <div class="flex flex-col items-center gap-y-3">
        <div :class="{'w-[88px] h-[116px]': !$slots.itemIcon}">
          <slot
            v-if="$slots.itemIcon"
            name="itemIcon"
          />
          <BoostCard
            v-else-if="('timeImage' in item)"
            :item="item as EcommercePrizeCardItem"
            only-visual
          />
          <ShopCard
            v-else
            :item="item"
            :is-buying="false"
            only-visual
          />
        </div>
        <div class="flex flex-col items-center text-center">
          <p class="text-2xl font-bold -tracking-[0.48px] text-light-white">
            <T
              key-name="shop.success.title"
              default-value="Purchase successful!"
            />
          </p>
          <div class="flex items-center text-center text-base font-medium text-white/60">
            <span v-if="isBOGO">2x&nbsp;</span>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <BaseButton
        class="w-full"
        @click="$emit('hide')"
      >
        <T
          key-name="shop.success.cta"
          default-value="Close"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>
